// extracted by mini-css-extract-plugin
export var instagramFeed = "instagram-feed-module--instagramFeed--3K_d2";
export var list = "instagram-feed-module--list--1Vs-Q";
export var item = "instagram-feed-module--item--39cEc";
export var itemLink = "instagram-feed-module--itemLink--1K9ff";
export var media = "instagram-feed-module--media--3Ie_k";